import React from 'react';

const Terms = () => {
  return (
    <div className="page-container">
      <h1>Terms of Service</h1>
      <p>
        By accessing and using UpDeals, you accept and agree to be bound by the terms and provision of this agreement.
      </p>
      <p>
        <strong>Deals and Pricing:</strong> Product prices, discount codes, and availability are accurate at the time of
        posting but may fluctuate or expire quickly due to high demand or retailer adjustments. UpDeals does not sell products
        directly and is not liable for price changes or order fulfillment by third-party retailers.
      </p>
      <p>
        <strong>External Links:</strong> UpDeals provides outbound hyperlinks to third-party e-commerce sites. We have no
        control over the content, terms, or privacy practices of those external destinations.
      </p>
    </div>
  );
};

export default Terms;
